// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"25fee044","453":"d855a71b","794":"23dbe398"}[chunkId] + ".chunk.js";
};